<template>
    <div>
        <app-notification v-if="getResponse" :level="level" v-show="isShowing" :message="message"></app-notification>

        <div v-if="!isSent">
            <form method="POST" action="/sendMail" autocomplete="off" @submit.prevent="onSubmit" @keyup="close">
                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input is-large" type="text" placeholder="Jaz sem*" v-model="name">
                        <span class="icon is-small is-left">
                            <i class="fa fa-user"></i>
                        </span>
                    </div>
                </div>
                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input is-large" type="text" placeholder="Moj e-dom*" v-model="email">
                        <span class="icon is-small is-left">
                            <i class="fa fa-envelope"></i>
                        </span>
                    </div>
                </div>
                <div class="field">
                    <div class="control has-icons-left">
                        <input class="input is-large" type="text" placeholder="Moj pravi dom (kraj)" v-model="place">
                        <span class="icon is-small is-left">
                            <i class="fa fa-home"></i>
                        </span>
                    </div>
                </div>

                <div class="field">
                    <p class="control has-icons-left has-icons-right">
                        <textarea class="textarea is-large" v-model="body" placeholder="In ti pišem ... *" rows="3"></textarea>
                    </p>
                </div>

                <div class="field">
                    <p class="control">
                        <a class="button is-info is-large is-block" @click="onSubmit" :class="classObj">Pošlji</a>
                    </p>
                </div>

            </form>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notification from '../../layout/Notifications';

export default {
    name: 'app-contact-form',
    props: ['theme'],
    data() {
        return {
            email: '',
            name: '',
            body: '',
            place: '',
            message: '',
            level: 'error',
            isShowing: false,
            isSent: false,
        }
    },

    components: {
        'app-notification': Notification,
    },

    computed: {
        ...mapGetters([
            'error',
            'loading',
            'success'
        ]),
        classObj() {
            if (this.loading) {
                return ' is-loading';
            }
        },

        getResponse() {
            if(this.error) {
                // console.log('geterrors: ', this.error);
                this.message = 'Vnesi manjkajoče informacije';
                this.level = 'error';
                this.isShowing = true;
                this.name = this.email = this.body = '';
                return true;
            }

            if(this.success) {
                this.message = 'Hvala za poslano sporočilo';
                this.level = 'success';
                this.isShowing = true;
                this.isSent = true;
                this.name = this.email = this.body = this.place = '';
                return true;
            }

            if(this.message !== '') {
                this.name = this.email = this.body = '';
                return true;
            }
        },

        getSuccess() {
            if(this.success) {
                this.message = 'Hvala za poslano sporočilo';
                this.level = 'success';
            }
        }
    },

    methods: {
        validate() {
            if (this.email === '' || this.name === '' || this.body === '') {
                this.message = 'Vsa polja so obvezna';
                this.level = "error";
                this.isShowing = true;
                // console.log('false: ', this.message, this.email, this.name, this.body);
                return false;
            }
            this.isShowing = false;
            this.message = '';
            // console.log('true: ', this.message, this.email, this.name, this.body, this.isShowing);
            return true;
        },

        onSubmit() {
            // console.log('submitted');
            if(this.validate()) {
                let contact = {
                    name: this.name,
                    email: this.email,
                    body: this.body,
                };

                this.$store.dispatch('sendMail', contact);
            }

        },
        close() {
            this.isShowing = false;
        }

    },

    mounted() {
        // console.log('Contact Form - Component mounted.')
    }
}
</script>

<style lang="scss">
@import '../../../style/app.scss';

form {
    max-width: 600px;
    margin: 0 auto;
}
input {
    font-weight: 300;
    &.input {
        border: none;
        background: transparent !important;
        border-bottom: 1px solid $th-black-05 !important;
        box-shadow: none !important;
    }
}
.textarea {
    border: none;
    box-shadow: none !important;
}
.button.is-info {
    background-color: rgba(0,0,0,0.1);
    border-color: transparent;
    color: $th-black-05;
    &:hover {
        color: $th-white-08 ;
        background-color: rgba(0,0,0,0.3);
    }
}

.field:not(:last-child) {
    margin-bottom: 1.25rem;
}

.darkbg-pannel {
    $baseBg: #9ED773;
    .fa {
        color: darken($baseBg, 20%) !important;
    }
    .button.is-info{
        color: darken($baseBg, 20%) !important;
        background-color: darken($baseBg, 10%) !important;
        &:hover {
            color: lighten($baseBg, 20%) !important;
            background-color: darken($baseBg, 10%) !important;
        }
    }
    .textarea{
        background-color: darken($baseBg, 10%) !important;
    }
    form {
        margin: 60px auto 0;
    }
}

.limegreen-pannel {
    $baseBg: rgba(50,205,50, 0.9);
    .fa {
        color: darken($baseBg, 5%) !important;
    }
    .button.is-info{
        color: darken($baseBg, 20%) !important;
        background-color: darken($baseBg, 3%) !important;
        &:hover {
            color: lighten($baseBg, 20%) !important;
            background-color: darken($baseBg, 10%) !important;
        }
    }
    input.input {
        border-bottom: 1px solid darken($baseBg, 20%) !important;
    }
    .textarea{
        background-color: darken($baseBg, 1%) !important;
    }
    form {
        margin: 60px auto 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/form/ContactForm.vue